module.exports = __webpack_public_path__ + "static/media/closeicon.e61ffba0.svg";